import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "user-search-box" }
const _hoisted_2 = { class: "user-search-box__search-bar" }
const _hoisted_3 = { class: "user-search-box__actions" }

import { TextBox, TextBoxChangeEvent } from '@progress/kendo-vue-inputs';
import { SvgIcon } from '@progress/kendo-vue-common';
import { xIcon } from '@progress/kendo-svg-icons';
import { computed, onMounted, ref } from 'vue';
import useTranslations from '@/composables/useTranslations';
import { Button as kButton } from '@progress/kendo-vue-buttons';
import { useRoute, useRouter } from 'vue-router';
import { useAppStore } from '@/stores/app.store';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserSearchBox',
  emits: ['search-clicked'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const { translate: t } = useTranslations();
const router = useRouter();
const route = useRoute();
const appStore = useAppStore();
const userSearchBoxInputRef = ref();
const searchPhrase = ref('');
const isInputValid = computed(() => searchPhrase.value.trim().length > 0);

function handleSearchInputChange(event: TextBoxChangeEvent) {
  searchPhrase.value = event.value as string;
}

function handleClearSearchBtnClick() {
  searchPhrase.value = '';
}

async function handleSearchBtnClick() {
  if (isInputValid.value) {
    emit('search-clicked');
    await search();
  }
}

async function search() {
  await router.push({ name: 'SearchResults', query: { searchPhrase: searchPhrase.value } });
}

onMounted(() => {
  if (!appStore.isMobile) userSearchBoxInputRef.value.focus();
  if (route?.query?.searchPhrase && route?.query?.searchPhrase?.length > 0) {
    searchPhrase.value = route?.query?.searchPhrase as string;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(TextBox), {
        id: "user-search-box__input",
        ref_key: "userSearchBoxInputRef",
        ref: userSearchBoxInputRef,
        "fill-mode": null,
        "input-suffix": 'suffix',
        placeholder: _unref(t)('Search'),
        size: null,
        value: searchPhrase.value,
        class: "user-search-box__input",
        onChange: handleSearchInputChange,
        onInput: handleSearchInputChange,
        onFocusout: handleSearchBtnClick,
        onKeyup: [
          _withKeys(handleSearchBtnClick, ["enter"]),
          _withKeys(handleSearchBtnClick, ["esc"])
        ]
      }, {
        suffix: _withCtx(() => [
          (searchPhrase.value?.length != 0)
            ? (_openBlock(), _createBlock(_unref(SvgIcon), {
                key: 0,
                icon: _unref(xIcon),
                class: "user-search-box__input-clear-button",
                onClick: handleClearSearchBtnClick,
                onKeyup: [
                  _withKeys(handleClearSearchBtnClick, ["enter"]),
                  _withKeys(handleSearchBtnClick, ["esc"])
                ]
              }, null, 8, ["icon"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["placeholder", "value"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(kButton), {
        class: _normalizeClass('user-search-box__search-button'),
        disabled: !isInputValid.value,
        "fill-mode": 'flat',
        "icon-class": 
          _unref(appStore)?.isMobile
            ? 'cwx-icon cwx-icon-before_zoom'
            : 'cwx-icon cwx-icon-before_arrow-chevron-right'
        ,
        size: 'large',
        onClick: handleSearchBtnClick
      }, null, 8, ["disabled", "icon-class"])
    ])
  ]))
}
}

})